import { AuthState } from '../types';

export function loading(state: AuthState) {
  state.loading = true;
}
